var indicative = require("indicative");

var Indicative = new indicative();

var url_or_deeplink = function(data, field, message, args, get) {
    return new Promise(function(resolve, reject) {
        var fieldValue = data[field];

        // resolve if value does not exists, value existence
        // should be taken care by required rule.
        if(!fieldValue) {
          return resolve('validation skipped')
        }

        if (Indicative.is.url(fieldValue) || /^\w+:\/\/\S+$/.test(fieldValue)) {
            return resolve('is valid url_or_deeplink');
        } else {
            return reject(message);
        }
    });
};

Indicative.extend('urlOrDeeplink', 'Should be a url or deeplink', url_or_deeplink);

var messageUtils = (function() {

    var _removeHelper = function(ids, removingId){
        return ids.filter(function(id){
            return id !== removingId;
        });
    };

    var _validate = function(formData) {
        var rules = {
            subjectText: 'required',
            subjectImage: 'url',
            text: 'required',
            actionImage: 'url',
            actionTarget: 'url_or_deeplink'
        };

        if(formData.sendPush){
            Object.assign(rules, {
                pushText: 'required',
                pushLink: 'url_or_deeplink'
            });
        }

        var messages = {
            "subjectText.required": "Subject is required",
            "subjectImage.url": "Subject Image should be a url",
            "text.required": "Message is required",
            "actionImage.url": "Action Image should be a url",
            "actionTarget.url_or_deeplink": "Action Target should be a url or deeplink",
            "pushText.required": "Push Text is required",
            "pushLink.url_or_deeplink": "Push Link should be a url or deeplink"
        };

        var data = {
            subjectText: formData.subjectText,
            subjectImage: formData.subjectImage,
            text: formData.text,
            actionImage: formData.actionImage,
            actionTarget: formData.actionTarget,
            pushText: formData.pushText,
            pushLink: formData.pushLink
        };

        return Indicative
            .validateAll(rules, data, messages)
            .then(function(validation_passed) {
                return true;
            })
            .catch(function(error) {
                var errorMessage = '';
                for (var i = 0, errorLength = error.length; i < errorLength; i++) {
                    errorMessage += error[i].message + '\n';
                };
                return errorMessage;
            });
    };

    return {
        removeHelper: _removeHelper,
        validate: _validate
    };

})();

module.exports = messageUtils;



// WEBPACK FOOTER //
// ./src/common/modules/message-center/messageUtils.js